import axios from 'axios';
import React from 'react';

class HeroAbout extends React.Component {
  constructor(props) {
    super(props);
    const dummyData = {
      title: {
        en: 'About Us – Learn Quran Easily testing'
      },
      description: {
        en: 'Welcome to Learn Quran Easily — your premier online destination for authentic Islamic education, accessible from the comfort of your home. We are committed to empowering seekers of knowledge across the globe through a transformative learning experience guided by esteemed Sunni scholars of Ahl al-Sunnah wal-Jama’ah.'
      },
      images: [
        { src: 'https://lqe-assets.learnquraneasily.in/1747638043972_IMG_about_1.jpg', name: ' Image 1' },
        { src: 'https://lqe-assets.learnquraneasily.in/1748252770803_IMG_about_2.jpg', name: ' Image 2' }
      ],
      sections: [
        {
          type: 'Our Goal',
          title: { 
            en: "Our Goal",
            ur: "ہمارا ہدف ",
            ro: "Hamara Hadaf "
          },
          content: { 
            en: "To blend timeless Islamic scholarship with modern technology, nurturing a deeper relationship with the Quran and Sunnah from wherever you are.",
            ur: "روایتی اسلامی علم کو جدید ٹیکنالوجی کے ساتھ جوڑنا، تاکہ آپ جہاں کہیں بھی ہوں قرآن اور سنت سے مضبوط تعلق قائم کر سکیں۔ ",
            ro: "Rawayati Islami Ilm Ko Jadeed Technology Ke Saath Jorna, Taake Aap Jahan Kahin Bhi Hon Quran Aur Sunnat Se Mazboot Talluq Qaim Kar Sakein."
          },
          image: 'https://lqe-assets.learnquraneasily.in/1747821408843_our-Goal.gif'
        },
        {
          type: 'Our Mission',
          title: { en: 'Our Mission' },
          content: { en: 'To deliver accessible, engaging, and transformative Islamic education to learners of every age, background, and location.' },
          image: 'https://lqe-assets.learnquraneasily.in/1747822041294_our-mission.png'
        },
      ]
    };

    const siteLanguage = localStorage.getItem('siteLanguage') || 'en';

    const goalSection = dummyData.sections.find(section => section.type === 'Our Goal');
    const missionSection = dummyData.sections.find(section => section.type === 'Our Mission');
    this.state = {
      siteLanguage: siteLanguage,
      aboutTitle: dummyData.title[siteLanguage],
      bannerText: dummyData.title[siteLanguage],
      images_big: dummyData.images[0],
      images_1: dummyData.images[1],
      description: dummyData.description[siteLanguage],
      visionImg: goalSection.image,
      visionTitle: goalSection.title[siteLanguage],
      visionText: goalSection.content[siteLanguage],
      missionImg: missionSection.image,
      missionTitle: missionSection.title[siteLanguage],
      missionText: missionSection.content[siteLanguage]
    };
  }  

  componentDidMount() {
     const BackendUrl = process.env.REACT_APP_BACKEND_API_URL;
    const { siteLanguage } = this.state;
    axios
      .post(`${BackendUrl}/about-us/multiple/1`)
      .then((response) => {
        const data = response.data.data[0];
        const goalSection = data.sections.find(section => section.type === "Our Goal");
        const missionSection = data.sections.find(section => section.type === "Our Mission");
        this.setState({
          aboutTitle: data.title[siteLanguage] || data.title.en,
          bannerText: data.title[siteLanguage] || data.title.en,
          images_big: data.images[0] || '',
          images_1: data.images[1] || '',
          // images_2: data.images[2] || '',
          description: data.description[siteLanguage] || data.description.en,
          visionImg: goalSection?.image || goalSection?.title.en,
          visionTitle: goalSection?.title[siteLanguage] || goalSection?.title.en,
          visionText: goalSection?.content[siteLanguage] || goalSection?.content.en,
          missionImg: missionSection?.image || missionSection?.title.en,
          missionTitle: missionSection?.title[siteLanguage] || missionSection?.title.en,
          missionText: missionSection?.content[siteLanguage] || missionSection?.content.en,
        });
  })
      .catch((error) => {
        console.error("Language fetch failed:", error);
      });
  }
  render() {
    const {
      aboutTitle,
      images_big,
      images_1,
      description,
      visionImg,
      visionTitle,
      visionText,
      missionImg,
      missionTitle,
      missionText,
      siteLanguage
    } = this.state

    return (
      <div className={`container-fluid about pt-3`}>
        <div className="container">
          <div className="row g-5">
            <div className="col-xl-6">
              <div className="row g-4">
                <div className="col-6">
                  <img src={images_big?.src} alt={images_big?.name} className="img-fluid h-100" />
                </div>
                <div className="col-6">
                  <img src={images_1?.src} alt={images_1?.name} className="img-fluid h-100 pb-0"/>
                </div>
              </div>

            </div>
            <div className={`col-xl-6 ${siteLanguage === 'ur' ? ' direction-rtl' : ''}`}>
              <p className="fs-5 text-uppercase text-primary">{aboutTitle}</p>
              <p className="pb-4">{description}</p>
              <div className="row g-4 mb-4">

                <div className="col-md-12">
                  <div className="ps-3 d-flex align-items-center justify-content-start">
                    <div className="about_img">
                      <img src={visionImg} alt={visionImg} className='img_primary'/>
                    </div>
                    <div className="mx-3">
                      <h5 className='text-primary'>{visionTitle}</h5>
                      <p>{visionText}</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="ps-3 d-flex align-items-center justify-content-start">
                     <div className="about_img">
                      <img src={missionImg} alt={missionImg} className='img_primary'/>
                    </div>
                    <div className="mx-3">
                      <h5 className='text-primary'>{missionTitle}</h5>
                      <p>{missionText}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HeroAbout;